module.exports = __webpack_public_path__ + "static/media/avatar.41443260.jpg";